/* RESPONSIBLE TEAM: team-automation-foundations */
import { fragment } from 'ember-data-model-fragments/attributes';
import Step from 'embercom/models/operator/visual-builder/step';
import { buildValidations, validator } from 'ember-cp-validations';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class TriggerMarketoCampaign extends Step.extend(Validations) {
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.triggerMarketoCampaign;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  static createNewStep(store: Store): TriggerMarketoCampaign {
    return store.createRecord('operator/visual-builder/step/trigger-marketo-campaign', {
      type: 'operator/visual-builder/step/trigger-marketo-campaign',
      action: store.createFragment('rules/rule-action', {
        type: 'trigger-marketo-campaign',
        justAdded: true,
      }),
    });
  }
}
